import i18next from "i18next";
import { FeatureFlagName, featureFlags } from "src/lib/featureFlags";
import translationEnglish from "src/translations/en.json";
import TranslationBloc from "@9amhealth/shared/src/lib/blocs/TranslateionBloc";
import type { TranslationKey } from "src/types/translationKey";

export default function translate(
  msg?: TranslationKey,
  variables: Record<string, unknown> = {},
  fallback?: TranslationKey
): string {
  if (!msg) {
    return "";
  }
  if (
    featureFlags.getFlag(FeatureFlagName.loggingTranslation) &&
    !(msg in translationEnglish)
  ) {
    // eslint-disable-next-line no-console
    console.warn("Translation key ", msg, " not defined in translation file");
  }

  let text: string;
  const formattedMsg = msg.replace(/-/g, "_");

  text = i18next.t(formattedMsg, variables);

  if (typeof fallback !== "undefined" && text === formattedMsg) {
    text = i18next.t(fallback, variables);
  } else if (text === formattedMsg) {
    text = msg;
  }
  return text;
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
TranslationBloc.setTranslateFn(translate as any);
